/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureDiskTarget } from '../models/AzureDiskTarget';

export class AzureDiskRestoreDestination {
  'azureDisk'?: AzureDiskTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "azureDisk",
      "baseName": "azureDisk",
      "type": "AzureDiskTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureDiskRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

